import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ServicesSection } from '../components/ServicesSection';
import { AboutSection } from '../components/AboutSection';
import { CareJourney } from '../components/CareJourney';
import { AssessmentCTA } from '../components/AssessmentCTA';
import { BlogSection } from '../components/BlogSection';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Quote, Star, ArrowRight } from 'lucide-react';
export function Home() {
  return <div className="min-h-screen bg-white font-sans selection:bg-primary/20 selection:text-primary" data-id="element-278">
      <Navbar data-id="element-279" />

      <main data-id="element-280">
        <Hero data-id="element-281" />

        {/* Trust Section / Logo Strip */}
        <section className="py-12 bg-white border-y border-gray-100" data-id="element-282">
          <div className="container mx-auto px-6" data-id="element-283">
            <div className="flex flex-wrap justify-center items-center gap-12 md:gap-24 opacity-50 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-284">
              {/* Placeholder for partner logos */}
              <div className="text-xl font-bold text-dark-text tracking-tighter" data-id="element-285">
                MARYLAND HEALTH
              </div>
              <div className="text-xl font-bold text-dark-text tracking-tighter" data-id="element-286">
                CARE FIRST
              </div>
              <div className="text-xl font-bold text-dark-text tracking-tighter" data-id="element-287">
                JOINT COMMISSION
              </div>
              <div className="text-xl font-bold text-dark-text tracking-tighter" data-id="element-288">
                MEDICAID APPROVED
              </div>
              <div className="text-xl font-bold text-dark-text tracking-tighter" data-id="element-289">
                LICENSED AGENCY
              </div>
            </div>
          </div>
        </section>

        <div id="about" data-id="element-290">
          <AboutSection data-id="element-291" />
        </div>
        <ServicesSection data-id="element-292" />
        <div id="process" data-id="element-293">
          <CareJourney data-id="element-294" />
        </div>

        {/* Mission Statement Section */}
        <section className="py-24 bg-accent relative overflow-hidden" data-id="element-295">
          <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-296">
            <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-297">
              <path d="M0 50 Q 25 0 50 50 T 100 50" stroke="currentColor" fill="none" strokeWidth="0.5" data-id="element-298" />
            </svg>
          </div>

          <div className="container mx-auto px-6 relative z-10" data-id="element-299">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="max-w-5xl mx-auto bg-white rounded-[60px] p-12 lg:p-24 text-center shadow-2xl shadow-primary/5" data-id="element-300">
              <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-10" data-id="element-301">
                <Quote className="w-10 h-10 text-primary fill-current" data-id="element-302" />
              </div>
              <h2 className="text-3xl lg:text-5xl font-heading font-bold text-dark-text leading-tight mb-10" data-id="element-303">
                "Our mission is to provide the highest quality of healthcare
                services with compassion, respect, and excellence, ensuring
                every individual thrives in the comfort of their own home."
              </h2>
              <div className="flex flex-col items-center" data-id="element-304">
                <div className="font-bold text-xl text-dark-text mb-2" data-id="element-305">
                  Harmony Healthcare Leadership
                </div>
                <div className="text-primary font-medium tracking-widest uppercase text-sm" data-id="element-306">
                  Excellence in Home Care
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Why Families Choose Us */}
        <section className="py-24 bg-white" data-id="element-307">
          <div className="container mx-auto px-6" data-id="element-308">
            <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-309">
              <span className="text-secondary font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-310">
                Why Choose Us
              </span>
              <h2 className="text-4xl lg:text-5xl font-heading font-bold text-dark-text mb-6" data-id="element-311">
                The Harmony Difference
              </h2>
              <p className="text-lg text-body-text" data-id="element-312">
                We go beyond basic care to provide a truly premium experience
                for families.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-313">
              {[{
              title: 'Compassionate Professionals',
              desc: 'Caregivers who truly care about your well-being.'
            }, {
              title: 'Individualized Care',
              desc: 'Plans designed around your unique medical needs.'
            }, {
              title: 'Reliable Scheduling',
              desc: 'Punctual and consistent care you can count on.'
            }, {
              title: 'Licensed Experts',
              desc: 'Fully vetted and highly trained medical staff.'
            }, {
              title: 'Family-Centered',
              desc: 'We keep your loved ones informed every step of the way.'
            }, {
              title: 'Flexible Options',
              desc: 'Care that adapts to your changing requirements.'
            }, {
              title: 'Emergency Support',
              desc: '24/7 availability for peace of mind.'
            }, {
              title: 'Transparent Communication',
              desc: 'Clear, honest, and frequent updates.'
            }].map((feature, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.05
            }} className="p-8 bg-background-secondary rounded-3xl hover:bg-white hover:shadow-xl transition-all duration-300 border border-transparent hover:border-gray-100 group" data-id="element-314">
                  <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center text-primary mb-6 shadow-sm group-hover:bg-primary group-hover:text-white transition-colors" data-id="element-315">
                    <Star className="w-6 h-6" data-id="element-316" />
                  </div>
                  <h4 className="font-bold text-dark-text mb-3" data-id="element-317">
                    {feature.title}
                  </h4>
                  <p className="text-sm text-body-text leading-relaxed" data-id="element-318">
                    {feature.desc}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-24 bg-background-secondary overflow-hidden" data-id="element-319">
          <div className="container mx-auto px-6" data-id="element-320">
            <div className="grid lg:grid-cols-2 gap-20 items-center" data-id="element-321">
              <div data-id="element-322">
                <span className="text-primary font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-323">
                  Testimonials
                </span>
                <h2 className="text-4xl lg:text-5xl font-heading font-bold text-dark-text mb-8" data-id="element-324">
                  Trusted by Families Across Maryland
                </h2>
                <div className="flex gap-2 mb-10" data-id="element-325">
                  {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-6 h-6 text-secondary fill-current" data-id="element-326" />)}
                  <span className="ml-4 font-bold text-dark-text" data-id="element-327">
                    5.0 Rating
                  </span>
                </div>
                <div className="flex gap-4" data-id="element-328">
                  <button className="w-14 h-14 rounded-full border border-gray-200 flex items-center justify-center hover:bg-white transition-all" data-id="element-329">
                    <ArrowRight className="w-6 h-6 rotate-180" data-id="element-330" />
                  </button>
                  <button className="w-14 h-14 rounded-full border border-gray-200 flex items-center justify-center hover:bg-white transition-all" data-id="element-331">
                    <ArrowRight className="w-6 h-6" data-id="element-332" />
                  </button>
                </div>
              </div>

              <motion.div initial={{
              opacity: 0,
              x: 50
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} className="relative" data-id="element-333">
                <div className="bg-white p-12 rounded-[48px] shadow-2xl relative z-10" data-id="element-334">
                  <Quote className="w-12 h-12 text-primary/10 absolute top-10 right-12" data-id="element-335" />
                  <p className="text-2xl text-dark-text italic leading-relaxed mb-10" data-id="element-336">
                    "Harmony Healthcare has been a godsend for our family. The
                    level of professionalism and genuine care they provide to my
                    mother is unmatched. We finally have peace of mind knowing
                    she's in excellent hands."
                  </p>
                  <div className="flex items-center gap-6" data-id="element-337">
                    <div className="w-16 h-16 rounded-full bg-accent overflow-hidden" data-id="element-338">
                      <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=150" alt="Sarah J." className="w-full h-full object-cover" data-id="element-339" />
                    </div>
                    <div data-id="element-340">
                      <div className="font-bold text-dark-text text-lg" data-id="element-341">
                        Sarah Jenkins
                      </div>
                      <div className="text-body-text" data-id="element-342">Pikesville, MD</div>
                    </div>
                  </div>
                </div>
                {/* Decorative Blobs */}
                <div className="absolute -top-10 -right-10 w-64 h-64 bg-primary/10 rounded-full blur-3xl -z-10" data-id="element-343" />
                <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-secondary/10 rounded-full blur-3xl -z-10" data-id="element-344" />
              </motion.div>
            </div>
          </div>
        </section>

        <BlogSection data-id="element-345" />
        <div id="contact" data-id="element-346">
          <AssessmentCTA data-id="element-347" />
        </div>
      </main>

      <Footer data-id="element-348" />
    </div>;
}